import { DatePicker } from "antd";
import dayjs from "dayjs";

const DatePickerComponent = ({ handleChange, min, max, style = {}, defaultValue }) => {
  const disabledDate = (current) => {
    return current && ((min && current < dayjs(min)) || (max && current > dayjs(max)));
  };

  return (
    <DatePicker
      onChange={handleChange}
      style={style}
      value={defaultValue ? dayjs(defaultValue) : null}
      disabledDate={disabledDate}
    />
  );
};

export default DatePickerComponent;
